// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_mz3C5 {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border: thin solid grey;
}

.input_vLhos {
  border: none;
}

.clearButton_hG1Vx {
  background-color: transparent;
  color: black;
}

.react-datetime-picker__wrapper {
  border: none !important;
}

.react-date-picker__wrapper {
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/DateTimePickerV2.css"],"names":[],"mappings":"AAAA;EACE,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".container {\n  width: fit-content;\n  border: thin solid grey;\n}\n\n.input {\n  border: none;\n}\n\n.clearButton {\n  background-color: transparent;\n  color: black;\n}\n\n:global(.react-datetime-picker__wrapper) {\n  border: none !important;\n}\n\n:global(.react-date-picker__wrapper) {\n  border: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_mz3C5`,
	"input": `input_vLhos`,
	"clearButton": `clearButton_hG1Vx`
};
export default ___CSS_LOADER_EXPORT___;
